var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.962 34.619v1.344c0 .494-.4.897-.897.897h-17.93a.897.897 0 0 1-.897-.897V23.412c0-.494.4-.897.897-.897h17.93c.494 0 .897.4.897.897v5.826M35.444 13.104l-7.495 6.073a.915.915 0 0 1-1.15 0l-7.494-6.073",
  stroke: "#5C6471",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m29.17 24.758-7.495 6.073a.915.915 0 0 1-1.149 0l-7.495-6.073M30.964 25.205h5.379c.494 0 .897-.4.897-.897V11.757c0-.494-.4-.897-.897-.897h-17.93c-.494 0-.897.4-.897.897v5.379",
  stroke: "#5C6471",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.653 17.138h-8.067M17.518 19.826h-6.276M19.309 19.826h.896",
  stroke: "#F15B35",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.757 34.62h-8.07M27.824 29.24h8.067M30.96 31.928h6.277M34.996 34.62h1.791M29.17 31.928h-.897",
  stroke: "#A4ABB7",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.234.5C37.347.5 47.97 11.026 47.97 24.001c0 12.975-10.623 23.501-23.736 23.501C11.122 47.502.5 36.976.5 24.001.5 11.026 11.122.501 24.234.5Z",
  stroke: "#A4ABB7"
})));
export default SvgMail;